import { createRouteRef, createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';
import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

const settingsRouteRef = createRouteRef({
  id: "user-settings"
});
const userSettingsPlugin = createPlugin({
  id: "user-settings",
  routes: {
    settingsPage: settingsRouteRef
  }
});
const UserSettingsPage = userSettingsPlugin.provide(
  createRoutableExtension({
    name: "UserSettingsPage",
    component: () => import('./index-2ff38412.esm.js').then((m) => m.SettingsPage),
    mountPoint: settingsRouteRef
  })
);

const userSettingsTranslationRef = createTranslationRef({
  id: "user-settings",
  messages: {
    languageToggle: {
      title: "Language",
      description: "Change the language",
      select: "Select language {{language}}"
    },
    themeToggle: {
      title: "Theme",
      description: "Change the theme mode",
      select: "Select theme {{theme}}",
      selectAuto: "Select Auto Theme",
      names: {
        light: "Light",
        dark: "Dark",
        auto: "Auto"
      }
    }
  }
});

export { UserSettingsPage as U, userSettingsTranslationRef as a, settingsRouteRef as s, userSettingsPlugin as u };
//# sourceMappingURL=translation-bd96c6ff.esm.js.map
